import { Notification, NotificationCreateInput } from "@bbb/model";
import { _apiRequest } from "./_apiClients";

export function listMyNotifications(token: string, signal?: AbortSignal) {
  return _apiRequest<Notification[]>("/v1/me/notifications", {
    token,
    signal,
  });
}

export function createMyNotification(
  token: string,
  payload: NotificationCreateInput,
  signal?: AbortSignal
) {
  return _apiRequest<Notification>("/v1/me/notifications", {
    method: "POST",
    token,
    data: payload,
    signal,
  });
}

export function markMyNotificationAsRead(token: string, notificationId: string) {
  return _apiRequest<Notification>(`/v1/me/notifications/${notificationId}/read`, {
    method: "PATCH",
    token,
    data: { read: true },
  });
}

export function markAllMyNotificationsAsRead(token: string) {
  return _apiRequest<{ updatedCount: number }>("/v1/me/notifications/read-all", {
    method: "PATCH",
    token,
    data: {},
  });
}

export function deleteMyNotification(token: string, notificationId: string) {
  return _apiRequest<{ deleted: boolean }>(`/v1/me/notifications/${notificationId}`, {
    method: "DELETE",
    token,
  });
}

export function deleteAllMyNotifications(token: string) {
  return _apiRequest<{ deletedCount: number }>("/v1/me/notifications", {
    method: "DELETE",
    token,
  });
}

export function getCommunityNotificationFollowStatus(token: string, communityId: string) {
  return _apiRequest<{ followed: boolean }>(
    `/v1/me/notifications/communities/${communityId}/follow`,
    {
      token,
    }
  );
}

export function followCommunityNotifications(token: string, communityId: string) {
  return _apiRequest<{ followed: boolean }>(
    `/v1/me/notifications/communities/${communityId}/follow`,
    {
      method: "POST",
      token,
    }
  );
}

export function unfollowCommunityNotifications(token: string, communityId: string) {
  return _apiRequest<{ followed: boolean }>(
    `/v1/me/notifications/communities/${communityId}/follow`,
    {
      method: "DELETE",
      token,
    }
  );
}
